// api.js
import Closesession from '../closesession';
import axiosInstance from './axiosMiddleware';

export const getData = async (endpoint, params) => {
    try {
        const response = await axiosInstance.get(endpoint, { params });
        return response.data;
    } catch (error) {
        if (error.response?.status === 401) { // Token expirado o no válido, redirige al usuario al login
            Closesession();
        }
        // Devolvé siempre un string, no un objeto
        const enrichedError = new Error(
            typeof error === 'string'
                ? error
                : error?.customMessage || error?.message || 'Ocurrió un error inesperado.'
        );
        enrichedError.endpoint = endpoint;
        enrichedError.request = params || null;
        enrichedError.response = error.response || null;
        throw enrichedError;
    }
};

export const postData = async (endpoint, data) => {
    try {
        const response = await axiosInstance.post(endpoint, data);

        return response.data;
    } catch (error) {
        if (error.response?.status === 401) { // Token expirado o no válido, redirige al usuario al login
            Closesession();
        }
        // 🔍 Extraer el mensaje que venga desde el backend, si existe
        const backendMessage =
        error.response?.data?.detail || // tu backend usa "detail"
        error.response?.data?.title || // a veces viene en "title"
        error.message ||                // fallback de JS
        'Ocurrió un error inesperado.';

        const enrichedError = new Error(backendMessage);

        enrichedError.endpoint = endpoint;
        enrichedError.request = data;
        enrichedError.response = error.response || null;

        throw enrichedError;
    }
};
export const pathData = async (endpoint, data) => {
    try {
        const response = await axiosInstance.patch(endpoint, data);

        return response.data;
    } catch (error) {
        if (error.response?.status === 401) { // Token expirado o no válido, redirige al usuario al login
            Closesession();
        }
        
        // 🔍 Extraer el mensaje que venga desde el backend, si existe
        const backendMessage =
            error.response?.data?.detail ||  // tu backend usa "detail"
            error.response?.data?.title ||   // a veces viene en "title"
            error.message ||                 // fallback de JS
            'Ocurrió un error inesperado.';

        const enrichedError = new Error(backendMessage);
        enrichedError.endpoint = endpoint;
        enrichedError.request = data;
        enrichedError.response = error.response || null;
        
        throw enrichedError;
    }
};
    export const deleteData = async (endpoint) => {
        try {
            const response = await axiosInstance.delete(endpoint);

            return response.data;
        } catch (error) {
            if (error.response?.status === 401) { // Token expirado o no válido, redirige al usuario al login
                Closesession();
            }

            const backendMessage =
                error.response?.data?.detail ||
                error.response?.data?.title ||
                error.message ||
                'Ocurrió un error inesperado.';

            const enrichedError = new Error(backendMessage);
            enrichedError.endpoint = endpoint;
            enrichedError.request = null;
            enrichedError.response = error.response || null;

            throw enrichedError;
        }
    };